import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "datepicker-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-3" }, [
  /*#__PURE__*/_createTextVNode("Który preparat antуkоnсерсji awaryjnej chciałabyś uzyskać? "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import Select from '../../ui/Select.vue';
import axios from 'axios';
import { useField } from 'vee-validate';
import { ref, onMounted } from 'vue';


export default {
  __name: 'ContraceptionMedicineField',
  setup(__props) {

const contraceptionOptions = ref([]);

const { value, errorMessage, setValue } = useField('contraceptionMedicine');

onMounted(() => {
    axios.get(`${jsData.siteUrl}/wp-json/doctor/v1/contraception-options`).then((response) => {
        contraceptionOptions.value = response.data;
        console.log(response.data);
    });
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Select, {
        options: contraceptionOptions.value,
        selected: _unref(value),
        onOnChange: _unref(setValue)
      }, null, 8, ["options", "selected", "onOnChange"])
    ]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}